import { axiosInstance } from 'common/utils/axios';
import useMutation from './useMutation';
import { getDefaultHeaders } from '../common/utils/headers';
import { useAuthModule } from '../hooks/native';
import { TOKEN_HEADER } from '../constants/headers';

const useAddInstruction = (options = {}) => {
  const { getAccessToken, inApp } = useAuthModule();
  return useMutation({
    mutationFn: async data => {
      const { guid, instruction, hashNumber } = data.variable;

      const defaultHeaders = getDefaultHeaders();
      const payload = { orderGUID: guid, instruction };

      if (hashNumber) {
        payload.utype = hashNumber;
      }

      if (!inApp) {
        return axiosInstance.put(
          'expresshub/web/v1/tracking/delivery/instruction',
          payload,
          {
            baseURL: window.Grab.config.endpoints.apiGateWay,
            headers: defaultHeaders,
          },
        );
      }

      const { result } = await getAccessToken();

      const headers = { ...defaultHeaders, [TOKEN_HEADER]: result || '' };

      return axiosInstance.put(
        'expresshub/web/v1/tracking/delivery/instruction',
        payload,
        {
          baseURL: window.Grab.config.endpoints.apiGateWay,
          headers,
        },
      );
    },
    ...options,
  });
};

export default useAddInstruction;
